import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ExceptionResolution, OrderHeader } from '@usf/ngrx-order';
import { ExceptionType } from '../../../pages/order-exceptions/constants/order-exception-type.enum';
import { ResolutionType } from '../../../pages/order-exceptions/constants/resolution-type.enum';
import { EmittedResolution } from '../../../pages/order-exceptions/models/emitted-resolution.model';

@Component({
  template: '',
})
export class DateRowBaseComponent {
  @Input() exceptionResolution: ExceptionResolution;
  @Input() exceptionType: ExceptionType;
  @Input() isOffline: boolean;
  @Input() orderHeader: OrderHeader;
  @Input() selectedDate: string;
  @Output() updateDateEmitter = new EventEmitter<any>();
  @Output() exceptionResolved = new EventEmitter();
  constructor() {}

  emitUpdateDate() {
    const resolution: EmittedResolution = {
      exceptionResolution: this.exceptionResolution,
      resolutionType: ResolutionType.DATE,
    };
    this.updateDateEmitter.emit(resolution);
  }

  confirm() {
    const defaultResolvedDate = !this.exceptionResolution?.resolutionDate
      ? this.orderHeader?.confirmedDeliveryDate
      : this.exceptionResolution?.resolutionDate;
    const resolution: EmittedResolution = {
      exceptionResolution: {
        ...this.exceptionResolution,
        expanded: false,
        dateCompleted: true,
        resolutionDate: defaultResolvedDate.toString(),
      },
      resolutionType: ResolutionType.DATE,
    };
    this.exceptionResolved.emit(resolution);
  }

  edit() {
    const resolution: EmittedResolution = {
      exceptionResolution: { ...this.exceptionResolution, expanded: true },
      resolutionType: ResolutionType.DATE,
    };
    this.exceptionResolved.emit(resolution);
  }
}
